import React from 'react';

export default function SVG(props: React.SVGAttributes<SVGElement>) {
    return (
        <svg
            className={props.className ? props.className : ''}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 60 60"
        >
            <path d="M4 39h46a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4v-8a4 4 0 0 1 4-4zm0 1.5A2.5 2.5 0 0 0 1.5 43v8A2.5 2.5 0 0 0 4 53.5h46a2.5 2.5 0 0 0 2.5-2.5v-8a2.5 2.5 0 0 0-2.5-2.5H4zM46.5 50a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM26.25 30.75V1.5a.75.75 0 1 1 1.5 0v29.25l9.283-8.843a.75.75 0 0 1 1.034 1.086L27.52 33.04l-.003.003a.75.75 0 0 1-1.037-.003L15.933 22.993a.75.75 0 0 1 1.034-1.086l9.283 8.843zM39.5 50a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
        </svg>
    );
}
